export default class SaveIdCardRequest {
    public personId: number | null = null;

    public idCardFront: number | null = null;

    public idCardBack: number | null = null;
}